/** @jsxImportSource @emotion/react */

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useState } from 'react'

import { bindActionToPromise } from '@sportninja/common/actions/utils'
import authActions from '@sportninja/common/actions/auth'

import UserSettingsModal from '../UserSettingsModal'

import { getSelfUser } from '@sportninja/common/selectors/users'

const AccountSettings = ({ button, changePassword, user, logout }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handlePasswordChange = async (values) => {
    const response = await changePassword(values)
    return response
  }

  return (
    <>
      {button({ onClick: handleOpenModal })}
      <UserSettingsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onPasswordChange={handlePasswordChange}
        userEmail={user?.email}
        userId={user?.id}
        userName={user?.fullName}
        userImageId={user?.imageId}
        onLogout={logout}
      />
    </>
  )
}

AccountSettings.propTypes = {
  button: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    user: getSelfUser(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: bindActionToPromise(dispatch, authActions.change.request),
    logout: bindActionToPromise(dispatch, authActions.logout.request),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings)
